import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators, NgForm } from '@angular/forms';
import { first } from 'rxjs/operators';
import { Router } from '@angular/router';
import {PlatformLocation } from '@angular/common';
import { ApiService } from '../api.service'
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {

  registerForm: FormGroup;
  isUserLogin:boolean;

  constructor(private fb: FormBuilder,
    private userApi: ApiService,
    private router:Router) { 
      this.registerForm = this.fb.group({
        email: ['', [Validators.required, Validators.maxLength(30), Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$")]],
        password: ['', Validators.required],
        name: ['', Validators.required],
        active: [false],
        post_type: ['users']
      });

      const newLocal = this.isUserLogin = this.userApi.isLoggedIn();
  
     }

  ngOnInit(): void {
  }

  postdata(registerForm1)
  {
    this.userApi.userRegistration(registerForm1.value.name,registerForm1.value.email,registerForm1.value.password,registerForm1.value.active,registerForm1.value.post_type)
    .pipe(first())
    .subscribe(
    data => {
      this.router.navigate(['user/login']);
    },
    error => {});
  }

  get email() { return this.registerForm.get('email'); }
  get password() { return this.registerForm.get('password'); }
  get name() { return this.registerForm.get('name'); }

  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: false,
    pullDrag: false,
    dots: false,
    navSpeed: 1500,
    navText: ['<', '>'],
    autoplay:true,
    animateIn: 'fadeIn', 
    animateOut: 'fadeOut',
    responsive: {
      0: {
        items: 1 
      },
      400: {
        items: 1
      },
      740: {
        items: 1
      },
      940: {
        items: 1
      }
    },
    nav: false
  }

}
